import type { SegmentViewPrefs } from "../utils/segment-view-prefs"

import { api } from "@/lib/api-client"

/**
 * §G9 Phase 3 (#2070): view prefs roam via the backend (E1) and named views can
 * be shared with explicit recipients picked from the M365 directory (E2).
 */
export type SharedViewRecipient = { oid: string; name: string }

export type SharedSegmentView = {
  viewId: string
  name: string
  createdBy: string
  createdByName: string
  recipients: SharedViewRecipient[]
  prefs: SegmentViewPrefs
  createdAt: string
  updatedAt: string
  isMine: boolean
}

export function fetchSegmentViewPrefs(): Promise<{ prefs: SegmentViewPrefs }> {
  return api.get<never, { prefs: SegmentViewPrefs }>("/segment-analysis/view-prefs")
}

export function saveSegmentViewPrefs(
  prefs: SegmentViewPrefs
): Promise<{ prefs: SegmentViewPrefs }> {
  return api.put<{ prefs: SegmentViewPrefs }, { prefs: SegmentViewPrefs }>(
    "/segment-analysis/view-prefs",
    { prefs }
  )
}

export function listSharedSegmentViews(): Promise<{
  views: SharedSegmentView[]
  canSeeAll: boolean
}> {
  return api.get<never, { views: SharedSegmentView[]; canSeeAll: boolean }>(
    "/segment-analysis/shared-views"
  )
}

export function createSharedSegmentView(input: {
  name: string
  prefs: SegmentViewPrefs
  recipients: SharedViewRecipient[]
}): Promise<SharedSegmentView> {
  return api.post<typeof input, SharedSegmentView>("/segment-analysis/shared-views", input)
}

export function deleteSharedSegmentView(viewId: string): Promise<{ deleted: boolean }> {
  return api.delete<never, { deleted: boolean }>(`/segment-analysis/shared-views/${viewId}`)
}
